import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const {
    t
  } = useLanguage();
  return <footer className="bg-corporate-dark text-white pt-20 pb-12 relative" data-id="element-41">
      <div className="absolute top-0 left-0 w-full h-px bg-accent-beige/30" data-id="element-42"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-16" data-id="element-44">
          {/* Brand Column */}
          <div className="space-y-8" data-id="element-45">
            <img src="https://cdn.magicpatterns.com/uploads/dGu33eyB5j7rueds66611Z/Logo_smartimport-1.png" alt="SmartImport Internacional" className="h-10 w-auto object-contain brightness-0 invert" data-id="element-46" />
            <p className="text-gray-300 text-sm leading-relaxed max-w-sm font-light" data-id="element-47">
              {t('footer.desc')}
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-48">
            <h3 className="font-heading font-semibold text-lg mb-8 text-white tracking-wide" data-id="element-49">
              {t('footer.nav')}
            </h3>
            <ul className="space-y-4" data-id="element-50">
              <li data-id="element-51">
                <Link to="/" className="text-gray-300 hover:text-accent-beige transition-colors duration-500 text-sm" data-id="element-52">
                  {t('nav.home')}
                </Link>
              </li>
              <li data-id="element-53">
                <a href="/#lineas-de-producto" onClick={e => {
                if (window.location.pathname === '/') {
                  e.preventDefault();
                  document.getElementById('lineas-de-producto')?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                  });
                }
              }} className="text-gray-300 hover:text-accent-beige transition-colors duration-500 text-sm" data-id="element-54">
                  {t('nav.solutions')}
                </a>
              </li>
              <li data-id="element-55">
                <a href="/#lineas-de-producto" onClick={e => {
                if (window.location.pathname === '/') {
                  e.preventDefault();
                  document.getElementById('lineas-de-producto')?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                  });
                }
              }} className="text-gray-300 hover:text-accent-beige transition-colors duration-500 text-sm" data-id="element-56">
                  {t('nav.catalog')}
                </a>
              </li>
              {/* TEMP HIDDEN: Documentación link — restore by uncommenting */}
              {/* <li>
               <Link
               to="/descargables"
               className="text-gray-300 hover:text-accent-beige transition-colors duration-500 text-sm"
               >
               {t('nav.downloads')}
               </Link>
               </li> */}
              <li data-id="element-57">
                <Link to="/empresa" className="text-gray-300 hover:text-accent-beige transition-colors duration-500 text-sm" data-id="element-58">
                  {t('nav.company')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Solutions Links */}
          <div data-id="element-59">
            <h3 className="font-heading font-semibold text-lg mb-8 text-white tracking-wide" data-id="element-60">
              {t('footer.products')}
            </h3>
            <ul className="space-y-4" data-id="element-61">
              <li data-id="element-62">
                <Link to="/soluciones/smartfloor" className="text-gray-300 hover:text-accent-beige transition-colors duration-500 text-sm" data-id="element-63">
                  SmartFloor
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/soluciones/smartpanel" className="text-gray-300 hover:text-accent-beige transition-colors duration-500 text-sm" data-id="element-65">
                  SmartPanel
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/soluciones/smartdoor" className="text-gray-300 hover:text-accent-beige transition-colors duration-500 text-sm" data-id="element-67">
                  SmartDoor
                </Link>
              </li>
              <li data-id="element-68">
                <Link to="/soluciones/smartstrips" className="text-gray-300 hover:text-accent-beige transition-colors duration-500 text-sm" data-id="element-69">
                  SmartPanel Exterior & Decorativo
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/soluciones/smartsofa" className="text-gray-300 hover:text-accent-beige transition-colors duration-500 text-sm" data-id="element-71">
                  SmartSofa
                </Link>
              </li>
              <li data-id="element-72">
                <Link to="/soluciones/smartmachinery" className="text-gray-300 hover:text-accent-beige transition-colors duration-500 text-sm" data-id="element-73">
                  SmartMachinery
                </Link>
              </li>
              <li data-id="element-74">
                <Link to="/soluciones/smartgarden" className="text-gray-300 hover:text-accent-beige transition-colors duration-500 text-sm" data-id="element-75">
                  SmartGarden
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-76">
          <p className="text-gray-400 text-xs text-center md:text-left font-light" data-id="element-77">
            &copy; {currentYear} {t('footer.rights')}
          </p>
          <div className="mt-6 md:mt-0 flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-2" data-id="element-78">
            <Link to="/aviso-legal" className="text-gray-400 text-xs hover:text-white transition-colors duration-500 font-light" data-id="element-79">
              {t('footer.legal')}
            </Link>
            <Link to="/privacidad" className="text-gray-400 text-xs hover:text-white transition-colors duration-500 font-light" data-id="element-80">
              {t('footer.privacy')}
            </Link>
            <Link to="/cookies" className="text-gray-400 text-xs hover:text-white transition-colors duration-500 font-light" data-id="element-81">
              {t('footer.cookies')}
            </Link>
            <Link to="/terminos" className="text-gray-400 text-xs hover:text-white transition-colors duration-500 font-light" data-id="element-82">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}